import { useUser } from "stores/useUser";

// Render children only if the current user has at least one of the allowed roles.
// Usage:
// <WithRole allowedRoles={["admin"]} fallback={null}>
//   <YourComponent />
// </WithRole>
const WithRole = ({ allowedRoles = [], fallback = null, children }) => {
  const { user } = useUser();

  const rolesFromUser = Array.isArray(user?.roles)
    ? user.roles
    : user?.role
    ? [user.role]
    : [];

  const isAuthorized = allowedRoles.length === 0
    ? true
    : rolesFromUser.some((r) => allowedRoles.includes(String(r)));

  return isAuthorized ? children : fallback;
};

export default WithRole;


